
import { useForm } from "react-hook-form";
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Grid, TextField } from "@material-ui/core";
import { changePasswordAction } from "../../../store/auth/actions";
import { getUserDetails } from "../../../store/auth/selectors";
import { Alert } from '@material-ui/lab';
import { basic, validationMessages } from '../../../config/validations';




export const ChangePasswordForm = (props) => {
    const { register, watch, control, getValues, reset, trigger, errors, handleSubmit } = useForm();
    const { onCompletion, onClose } = props;
    const [importError, setImportError] = useState('');
    const [validationError, setValidationError] = useState(false);
    const [disableChange, setDisableChange] = useState(false);

    const dispatch = useDispatch();
    const userDetails = useSelector(getUserDetails);

    const currentPassword = watch("currentpassword");
    const newPassword = watch("newpassword");
    const confirmPassword = watch("confirmpassword");

    const inputsToChangePassword = { currentPassword, newPassword, confirmPassword, logedUserName: userDetails.loggedInUsername, loggerUserId: userDetails.loggedInUserId };

    const changePasssword = async () => {
        if (newPassword !== confirmPassword) {
            setImportError('New password and confirm password does not match')
        }
        else if (currentPassword === '' || currentPassword === undefined) {
            setValidationError(true);
        }
        else {
            const response = await dispatch(changePasswordAction(inputsToChangePassword));
            if (response.status === true) {
                onCompletion();
                onClose();
            }
            else {
                setImportError(response.message)
            }

        }

    }

    const validateCurrentPassword = () => {
        if (currentPassword == '' || currentPassword == undefined) {
            setValidationError(true);
            //setDisableChange(true);
        }
    }

    const messages = {
        ...validationMessages,
        //validate: 'This digital twin name is already used'
    };

    return (
        <Grid container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    InputLabelProps={{
                        shrink: true,
                    }}
                    type="password"
                    fullWidth
                    required
                    label={"Current Password"}
                    placeholder={"Current Password"}
                    variant="outlined"
                    name={"currentpassword"}
                    error={validationError}
                    onBlur={validateCurrentPassword}
                    helperText={validationError ? 'Please enter the current password' : ' '}
                    inputRef={register({ required: true, validate: "validateNameLabel" })}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    InputLabelProps={{
                        shrink: true,
                    }}
                    type="password"
                    fullWidth
                    required
                    label={"New Password"}
                    placeholder={"New Password"}
                    variant="outlined"
                    name="newpassword"
                    // error={Boolean(errors.title)}
                    inputRef={register({ ...basic, required: true, validate: "validateLabel" })}
                    error={errors?.newpassword ? true : false}
                    helperText={errors?.newpassword ? messages[errors?.newpassword?.type] : ''}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    InputLabelProps={{
                        shrink: true,
                    }}
                    type="password"
                    fullWidth
                    required
                    label={"Confirm Password"}
                    placeholder={"Confirm Password"}
                    variant="outlined"
                    name="confirmpassword"
                    error={Boolean(errors.title)}
                    inputRef={register({ required: true, validate: "oj" })}
                />

            </Grid>
            <Grid item xs={12}>
                {importError != '' && <Alert severity="error">{importError}</Alert>}
            </Grid>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button onClick={onClose} color="primary" variant="outlined" style={{ marginLeft: 10 }}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit(changePasssword)} color="primary" variant="contained" style={{ marginLeft: 10 }}>
                    Change
                </Button>
            </Grid>
        </Grid>
    )

} 